import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        py: 8,
        mt: 8,
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/')}
          sx={{
            mb: 4,
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'rgba(108, 59, 248, 0.08)',
            },
          }}
        >
          Back to Home
        </Button>

        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h3" component="h1" gutterBottom>
            Terms of Service
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            1. Agreement to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using SMOD's services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing our services.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            2. Use License
          </Typography>
          <Typography variant="body1" paragraph>
            Permission is granted to temporarily access and use SMOD's services for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose</li>
            <li>Attempt to decompile or reverse engineer any software contained in SMOD's services</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            3. Service Description
          </Typography>
          <Typography variant="body1" paragraph>
            SMOD provides a platform for managing sales rewards and dealer incentives. We reserve the right to withdraw or amend our service, and any service or material we provide, in our sole discretion without notice. We will not be liable if for any reason all or any part of the service is unavailable at any time or for any period.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            4. User Obligations
          </Typography>
          <Typography variant="body1" paragraph>
            As a user of the service, you agree to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Promptly notify us of any unauthorized use of your account</li>
            <li>Use the service in compliance with all applicable laws and regulations</li>
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            5. Payment Terms
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to pay all fees or charges to your account based on the fees, charges, and billing terms in effect at the time a fee or charge is due and payable. If auto-renewal is enabled for the services you have subscribed to, you agree that we may charge your payment method for renewals.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            In no event shall SMOD, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
            7. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            Questions about the Terms of Service should be sent to us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email: info@thesmod.com
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService; 